import { getAxiosData, getCommas } from "@/assets/js/function";
import store from "@/store";
import { useRouter } from "vue-router";

/**
 * @description 강사 강의 관리
 */
export async function getLectList(params) 
{
    console.log(params);
    const router = useRouter();

    try 
    {
        let ing    = 0;
        let comp   = 0;

        const res = await getAxiosData("https://data.wecls.com/inst/dashboard/lectManage", params);

        console.log(res);

        const list = [];

        res.data['list'].map((item) => {
            if(item.compYn === '진행중')
            {
                ing++;
            }
            else if(item.compYn === '강의완료')
            {
                comp++;
            }
            const date          = item.lectPeriod;
            const lectPeriod    = date.split('~');
            
            const startDate = lectPeriod[0];
            const endDate   = lectPeriod[1];

            list.push({
                lcCd        : item.lcCd,
                regDt       : item.regDt,
                lectStart   : startDate,
                lectEnd     : endDate,
                name        : item.name,
                subject     : item.subject,
                amt         : getCommas(Number(item.amt)),
                compYn      : item.compYn
            })
        });

        /** 필터링 값 */
        const filters = [
            { title : '진행 강의', count : ing },
            { title : '완료 강의', count : comp },
            { title : '전체', count : list.length }
        ];

        store.commit('lect/setFilters', filters);
        store.commit("lect/setAllList", list);
    } 
    catch (error) 
    {
        console.error(error);
        const check = error.response.data.message.includes('NotAuthorizedException');

        if(error.response.data.status === 401 || check)
        {
            alert('로그인 세션이 만료되었습니다. 로그인 페이지로 이동합니다.');
            store.dispatch('login/logout', 'inst');
            router.push('/login');
        }
        else
        {
            alert(error.response.data.data+'입니다. 이전 페이지로 이동합니다.');
            history.back();
        }
    }
}
